import { useLineChart } from '@/composables/useLineChart'
import { useReportStore } from '@/store/report'
import { storeToRefs } from 'pinia'
import { watch } from 'vue'

export function useTemperatureChart() {
  const reportStore = useReportStore()
  const { basePeriod } = storeToRefs(reportStore)

  const { series, chartOptions, setTimeRange, updateSeries, processReadings } = useLineChart({
    chartId: 'temperature-base-chart',
    exportConfig: {
      filename: 'temperatura-base',
      unit: 'C',
    },
    yAxisFormatter: (value: number) => `${value?.toFixed(0)} C`,
    tooltipYFormatter: (val: number) => `${val?.toFixed(2)} C`,
    unit: 'C',
  })

  // Configurar range de tempo
  const [startDate, endDate] = basePeriod.value || []
  setTimeRange(startDate, endDate)

  // Processar dados iniciais
  const sensorData = reportStore.getBaseTemperatureReadings || []
  const processedSeries = sensorData.map((sensor) => ({
    name: sensor.sensorName,
    data: processReadings(sensor.readings, 'time', 'value'),
  }))
  updateSeries(processedSeries)

  // Observar mudanças nos dados
  watch(
    () => reportStore.getBaseTemperatureReadings,
    (newData) => {
      const processedSeries = (newData || []).map((sensor) => ({
        name: sensor.sensorName,
        data: processReadings(sensor.readings, 'time', 'value'),
      }))
      updateSeries(processedSeries)
    },
    { immediate: true },
  )

  // Observar mudanças no período
  watch(
    () => basePeriod.value,
    ([startDate, endDate]) => {
      setTimeRange(startDate, endDate)
    },
  )

  return { chartOptions, series }
}

export function useCompareTemperatureChart() {
  const reportStore = useReportStore()
  const { comparePeriod } = storeToRefs(reportStore)

  const { series, chartOptions, setTimeRange, updateSeries, processReadings } = useLineChart({
    chartId: 'temperature-compare-chart',
    exportConfig: {
      filename: 'temperatura-compare',
      unit: 'C',
    },
    yAxisFormatter: (value: number) => `${value?.toFixed(0)} C`,
    tooltipYFormatter: (val: number) => `${val?.toFixed(2)} C`,
    unit: 'C',
  })

  // Configurar range de tempo
  const [startDate, endDate] = comparePeriod.value || []
  setTimeRange(startDate, endDate)

  // Processar dados iniciais
  const sensorData = reportStore.getCompareTemperatureReadings || []
  const processedSeries = sensorData.map((sensor) => ({
    name: sensor.sensorName,
    data: processReadings(sensor.readings, 'time', 'value'),
  }))
  updateSeries(processedSeries)

  // Observar mudanças nos dados
  watch(
    () => reportStore.getCompareTemperatureReadings,
    (newData) => {
      const processedSeries = (newData || []).map((sensor) => ({
        name: sensor.sensorName,
        data: processReadings(sensor.readings, 'time', 'value'),
      }))
      updateSeries(processedSeries)
    },
    { immediate: true },
  )

  // Observar mudanças no período
  watch(
    () => comparePeriod.value,
    ([startDate, endDate]) => {
      setTimeRange(startDate, endDate)
    },
  )

  return { chartOptions, series }
}
